import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { StatusBadge, InvoiceBadge, formatDate } from '../components/shared';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.getStats().then(setStats).catch(() => {});
    api.getTickets({ status: 'received' }).then(t => {
      api.getTickets({ status: 'in_repair' }).then(t2 => setTickets([...t, ...t2].slice(0, 8)));
    }).catch(() => {});
  }, []);

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">DASHBOARD <span>_</span></h1>
      </div>

      {stats && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-label">Total Devices</div>
            <div className="stat-value blue">{stats.devices}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Open Tickets</div>
            <div className="stat-value yellow">{stats.tickets_open}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Delivered</div>
            <div className="stat-value green">{stats.tickets_delivered}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Invoices Issued</div>
            <div className="stat-value yellow">{stats.invoices_issued}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Invoices Sent</div>
            <div className="stat-value blue">{stats.invoices_sent}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Invoices Paid</div>
            <div className="stat-value green">{stats.invoices_paid}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Faulty Parts</div>
            <div className="stat-value red">{stats.parts_faulty}</div>
          </div>
        </div>
      )}

      <div className="section-title">Active Tickets</div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Device</th>
              <th>Serial</th>
              <th>Fault</th>
              <th>Status</th>
              <th>Received</th>
            </tr>
          </thead>
          <tbody>
            {tickets.length === 0 ? (
              <tr><td colSpan={5}><div className="empty">No active tickets</div></td></tr>
            ) : tickets.map(t => (
              <tr key={t.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/tickets/${t.id}`)}>
                <td className="fw-500">{t.device_name}</td>
                <td><span className="mono">{t.device_serial}</span></td>
                <td className="text-muted text-sm">{t.fault_description || '—'}</td>
                <td><StatusBadge status={t.status} /></td>
                <td className="mono text-sm text-dim">{formatDate(t.received_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
